<template>
    <a
        href="#"
        @click="openSidebar"
    >
        <span class="filter-btn text-decoration-underline habiteo-body-2">
            {{ $t('cutawayHeader.filters') }}
        </span>
    </a>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
    name: "TextButton",
    methods: {
        openSidebar() {
            EventBus.$emit('toggleSidebar',true);
        }
    }

}
</script>
<style lang="scss">
    .filter-btn {
        color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/cutawayHeader/components/TextButton.vue